import Api from '../Api';

import { url } from './config';
import { SupplierAccount } from './types';

const api = new Api<SupplierAccount>(url);

export default api;
